/* F2 ECO B2B-Anmeldung */
(function () {
  'use strict';
  var app = document.getElementById('f2b-app');
  var card = document.getElementById('f2b-card');
  if (!app || !card) return;

  function readJson(id) { try { return JSON.parse(document.getElementById(id).textContent); } catch (e) { return null; } }
  var CFG = readJson('f2b-cfg') || {};
  var SRV = readJson('f2b-state') || {};
  var LANG = CFG.lang === 'de' ? 'de' : 'en';
  var CD = window.F2B_COUNTRIES || { D: {}, L: [] };

  /* ---------- Texte ---------- */
  var TX = {
    de: {
      kicker: 'Registrierung für Werften und Händler', back: '‹ zurück', next: 'Weiter', send: 'Anmeldung senden', sending: 'Wird gesendet …',
      opt: '(optional)', choose: 'Bitte wählen', meter: 'Meter',
      login: 'Schon registriert? Jetzt einloggen →',
      b2bIn: 'Ihr seid schon mit einem Händlerkonto angemeldet.', b2bShop: 'Zum Shop →',
      e_req: 'Bitte ausfüllen.', e_pick: 'Bitte wählen.', e_mail: 'Bitte eine gültige E-Mail-Adresse eingeben.',
      e_num: 'Bitte eine Zahl in Metern eingeben, z. B. 11,5.', e_tel: 'Bitte eine Telefonnummer eingeben.',
      e_web: 'Bitte eine Website oder einen Profil-Link eingeben.', e_ok: 'Bitte die Datenschutzerklärung bestätigen.',
      e_send: 'Das Senden hat nicht geklappt. Bitte prüft eure Angaben und sendet noch einmal oder schreibt uns an {mail}.',
      segment: 'Euer Betrieb ist...',
      seg_werft: 'Werft oder Servicebetrieb', seg_werft_d: 'Ihr tragt F2 auf Booten eurer Kunden auf.',
      seg_haendler: 'Händler', seg_haendler_d: 'Ihr verkauft F2 an eure Kunden weiter.',
      w_groesse: 'Auf welche Bootsgrößen seid ihr spezialisiert?',
      g_b10: 'Bis 10 m', g_10_15: '10–15 m', g_15_24: '15–24 m', g_24: 'Über 24 m',
      w_projekt: 'Habt ihr aktuell ein konkretes Projekt?',
      p_ja: 'Ja, ein bestimmtes Boot', p_ja_d: 'Mit den Bootsmaßen schicken wir euch gleich ein Angebot.',
      p_nein: 'Nein, noch nicht', p_nein_d: 'Ihr wollt erst einmal Partner werden.',
      bootstyp: 'Das Boot ist ein...', b_motor: 'Motorboot', b_segel: 'Segelboot', b_kat: 'Katamaran',
      kiel: 'Der Kiel ist ein...', k_kurz: 'Kurz- oder Flossenkiel', k_lang: 'Langkiel', k_gem: 'Dazwischen oder unsicher',
      masse: 'Die Maße des Bootes sind...', m_l: 'Länge in der Wasserlinie', m_l_h: 'Ist sie nicht bekannt, die Gesamtlänge nehmen.',
      m_b: 'Maximale Breite', m_b_kat: 'Gesamtbreite über beide Rümpfe.', m_t: 'Tiefgang',
      h_kanal: 'Ihr verkauft...', c_laden: 'Im Ladengeschäft', c_online: 'Online', c_beides: 'Im Laden und online',
      h_lager: 'Haltet ihr Ware auf Lager oder bestellt ihr pro Kundenauftrag?', l_lager: 'Auf Lager', l_auftrag: 'Pro Kundenauftrag', l_beides: 'Beides',
      h_appl: 'Bietet ihr die Applikation auch selbst an?', a_ja: 'Ja, im eigenen Betrieb', a_nein: 'Nein, wir verkaufen nur', a_partner: 'Wir vermitteln an Partnerbetriebe',
      h_sortiment: 'Führt ihr bereits Antifouling im Sortiment?', s_ja: 'Ja', s_nein: 'Nein',
      h_umsatz: 'Wie viel Umsatz macht ihr ungefähr mit Antifouling pro Jahr?', h_umsatz_l: 'Eine grobe Größenordnung reicht.',
      u_25: 'Unter €25.000', u_25_100: '€25.000–100.000', u_100_250: '€100.000–250.000', u_250: 'Über €250.000', u_ka: 'Keine Angabe',
      h_marken: 'Sortiment und Verkaufsgebiet', h_marken_n: 'Euer Verkaufsgebiet',
      f_marken: 'Antifouling-Marken, die ihr aktuell führt', f_marken_ph: 'Marken, durch Komma getrennt',
      f_gebiet: 'Euer Verkaufsgebiet', f_gebiet_n: 'Wo verkauft ihr?', f_gebiet_ph: 'z. B. Kärnten und Slowenien',
      firma: 'Eure Firma', f_firma: 'Firmenname', f_land: 'Land', f_uid_eu: 'UID / USt-IdNr.', f_uid: 'Steuernummer',
      f_plz: 'PLZ', f_eircode: 'Eircode',
      f_web: 'Website', f_web_h: 'Keine Website? Dann der Link zu eurem Google- oder Instagram-Profil.',
      kontakt: 'Euer Ansprechpartner', k_vn: 'Vorname', k_nn: 'Nachname', k_mail: 'E-Mail', k_tel: 'Telefon',
      k_quelle: 'Wie seid ihr auf F2 aufmerksam geworden?', q_kunde: 'Kunden haben nach F2 gefragt', q_empfehlung: 'Empfehlung',
      q_suche: 'Online-Suche', q_social: 'Social Media oder YouTube', q_messe: 'Messe', q_anderes: 'Anderes',
      k_msg: 'Nachricht', k_msg_ph: 'Fragen, Wünsche, Details zu eurem Betrieb',
      k_ok: 'Ich habe die <a href="{url}" target="_blank" rel="noopener">Datenschutzerklärung</a> gelesen und bin einverstanden, dass ihr meine Angaben für die Anmeldung verwendet.',
      done: 'Danke, eure Anmeldung ist eingegangen.',
      done_b: 'Wir melden uns innerhalb von zwei Werktagen', done_t: ' mit euren Konditionen und dem Zugang zum Händlerbereich.',
      cal_tel: 'Zu eurem Projekt sprechen wir am besten kurz am Telefon: Preis, Liefertermin und Untergrundvorbereitung.',
      cal_tel_btn: '15-Minuten-Rückruf vereinbaren', cal_tel_cap: 'Telefon, 15 Minuten. Ihr wählt den Termin.',
      cal_note_proj: 'Projekt', cal_note_firma: 'Firma'
    },
    en: {
      kicker: 'Registration for boatyards and dealers', back: '‹ back', next: 'Next', send: 'Send registration', sending: 'Sending …',
      opt: '(optional)', choose: 'Please choose', meter: 'metres',
      login: 'Already registered? Log in →',
      b2bIn: 'You are already logged in with a trade account.', b2bShop: 'Go to the shop →',
      e_req: 'Please fill in this field.', e_pick: 'Please choose.', e_mail: 'Please enter a valid email address.',
      e_num: 'Please enter a number in metres, e.g. 11.5.', e_tel: 'Please enter a phone number.',
      e_web: 'Please enter a website or a profile link.', e_ok: 'Please confirm the privacy policy.',
      e_send: 'Sending did not work. Please check your details and send again, or write to us at {mail}.',
      segment: 'Your business is...',
      seg_werft: 'Boatyard or service business', seg_werft_d: 'You apply F2 to your customers’ boats.',
      seg_haendler: 'Dealer', seg_haendler_d: 'You resell F2 to your customers.',
      w_groesse: 'Which boat sizes do you specialise in?',
      g_b10: 'Up to 10 m', g_10_15: '10–15 m', g_15_24: '15–24 m', g_24: 'Over 24 m',
      w_projekt: 'Do you have a specific project right now?',
      p_ja: 'Yes, a specific boat', p_ja_d: 'With the boat’s dimensions we will send you a quote straight away.',
      p_nein: 'No, not yet', p_nein_d: 'You would like to become a partner first.',
      bootstyp: 'The boat is a...', b_motor: 'Motorboat', b_segel: 'Sailing boat', b_kat: 'Catamaran',
      kiel: 'The keel is a...', k_kurz: 'Short or fin keel', k_lang: 'Long keel', k_gem: 'In between or not sure',
      masse: 'The boat’s dimensions are...', m_l: 'Waterline length', m_l_h: 'If you do not know it, use the overall length.',
      m_b: 'Maximum beam', m_b_kat: 'Total beam across both hulls.', m_t: 'Draft',
      h_kanal: 'You sell...', c_laden: 'In a shop', c_online: 'Online', c_beides: 'In a shop and online',
      h_lager: 'Do you keep stock or order per customer job?', l_lager: 'In stock', l_auftrag: 'Per customer order', l_beides: 'Both',
      h_appl: 'Do you also offer the application yourselves?', a_ja: 'Yes, in our own workshop', a_nein: 'No, we only sell', a_partner: 'We refer customers to partner yards',
      h_sortiment: 'Do you already stock antifouling?', s_ja: 'Yes', s_nein: 'No',
      h_umsatz: 'Roughly how much antifouling revenue do you make per year?', h_umsatz_l: 'A rough figure is enough.',
      u_25: 'Under €25,000', u_25_100: '€25,000–100,000', u_100_250: '€100,000–250,000', u_250: 'Over €250,000', u_ka: 'Prefer not to say',
      h_marken: 'Range and sales area', h_marken_n: 'Your sales area',
      f_marken: 'Antifouling brands you currently stock', f_marken_ph: 'Brands, separated by commas',
      f_gebiet: 'Your sales area', f_gebiet_n: 'Where do you sell?', f_gebiet_ph: 'e.g. Carinthia and Slovenia',
      firma: 'Your company', f_firma: 'Company name', f_land: 'Country', f_uid_eu: 'VAT ID', f_uid: 'Tax number',
      f_plz: '', f_eircode: 'Eircode',
      f_web: 'Website', f_web_h: 'No website? Then the link to your Google or Instagram profile.',
      kontakt: 'Your contact person', k_vn: 'First name', k_nn: 'Last name', k_mail: 'Email', k_tel: 'Phone',
      k_quelle: 'How did you hear about F2?', q_kunde: 'Customers asked for F2', q_empfehlung: 'Recommendation',
      q_suche: 'Online search', q_social: 'Social media or YouTube', q_messe: 'Trade show', q_anderes: 'Other',
      k_msg: 'Message', k_msg_ph: 'Questions, requests, details about your business',
      k_ok: 'I have read the <a href="{url}" target="_blank" rel="noopener">privacy policy</a> and agree that you use my details for the registration.',
      done: 'Thank you, your registration has been received.',
      done_b: 'We will get back to you within two working days', done_t: ' with your terms and access to the trade area.',
      cal_tel: 'For your project, a short phone call works best: price, delivery date and surface preparation.',
      cal_tel_btn: 'Book a 15-minute call back', cal_tel_cap: 'Phone, 15 minutes. You choose the time.',
      cal_note_proj: 'Project', cal_note_firma: 'Company'
    }
  };
  var T = TX[LANG], TD = TX.de;
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- Laender ---------- */
  var EU = 'AT BE BG CY CZ DE DK EE ES FI FR GR HR HU IE IT LT LU LV MT NL PL PT RO SE SI SK'.split(' ');
  var UIDX = { AT: 'ATU12345678', BE: 'BE0123456789', BG: 'BG123456789', CY: 'CY12345678X', CZ: 'CZ12345678', DE: 'DE123456789',
    DK: 'DK12345678', EE: 'EE123456789', ES: 'ESB12345678', FI: 'FI12345678', FR: 'FR12345678901', GR: 'EL123456789',
    HR: 'HR12345678901', HU: 'HU12345678', IE: 'IE1234567WA', IT: 'IT12345678901', LT: 'LT123456789', LU: 'LU12345678',
    LV: 'LV12345678901', MT: 'MT12345678', NL: 'NL123456789B01', PL: 'PL1234567890', PT: 'PT123456789', RO: 'RO1234567890',
    SE: 'SE123456789001', SI: 'SI12345678', SK: 'SK1234567890', CH: 'CHE-123.456.789' };
  var TOP = ['DE', 'AT', 'CH', 'IT', 'HR', 'ES', 'FR', 'NL'];
  function esOutside() { return land().c === 'ES' && ['GC', 'TF', 'CE', 'ML'].indexOf(S.v.f_zone) > -1; }
  var BYC = {};
  CD.L.forEach(function (c) { BYC[c.c] = c; });
  function cName(c, lang) { return (lang || LANG) === 'de' ? c.n : (c.e || c.n); }
  function lab(c, key, lang) { var v = c[key] || CD.D[key] || ['', '']; return (lang || LANG) === 'de' ? v[0] : v[1]; }
  var SORTED = CD.L.slice().sort(function (a, b) { return cName(a).localeCompare(cName(b), LANG); });
  var B2BC = String(CFG.b2bCountries || '').split(/[\s,;]+/).filter(Boolean);

  /* ---------- Zustand ---------- */
  var KEY = 'f2b_state', SENT = 'f2b_sent', DONE = 'f2b_done', TTL = 60 * 60 * 1000;
  function ssGet(k) { try { return JSON.parse(sessionStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function ssSet(k, v) { try { if (v == null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  var S = { step: 'segment', a: {}, v: {} };
  var defCountry = BYC[CFG.country] ? CFG.country : 'DE';
  function save() { ssSet(KEY, { t: Date.now(), step: S.step, a: S.a, v: S.v }); }

  /* ---------- Ablauf ---------- */
  function flowNext(step, a) {
    switch (step) {
      case 'segment': return a.seg === 'haendler' ? 'h_kanal' : 'w_groesse';
      case 'w_groesse': return 'w_projekt';
      case 'w_projekt': return a.proj === 'nein' ? 'firma' : 'bootstyp';
      case 'bootstyp': return a.boot === 'segel' ? 'kiel' : 'masse';
      case 'kiel': return 'masse';
      case 'masse': return 'firma';
      case 'h_kanal': return 'h_lager';
      case 'h_lager': return 'h_appl';
      case 'h_appl': return 'h_sortiment';
      case 'h_sortiment': return a.sort === 'nein' ? 'h_marken' : 'h_umsatz';
      case 'h_umsatz': return 'h_marken';
      case 'h_marken': return 'firma';
      case 'firma': return 'kontakt';
      default: return 'done';
    }
  }
  function path(a) {
    var p = ['segment'], s = 'segment', g = 0;
    while (g++ < 20) { s = flowNext(s, a); if (s === 'done') break; p.push(s); }
    return p;
  }

  /* ---------- Schritte ---------- */
  function tile(id, k, dk) { return { id: id, k: k, dk: dk || '' }; }
  var TILES = {
    segment: { key: 'seg', tiles: [tile('werft', 'seg_werft', 'seg_werft_d'), tile('haendler', 'seg_haendler', 'seg_haendler_d')] },
    w_groesse: { key: 'groesse', tiles: [tile('b10', 'g_b10'), tile('10-15', 'g_10_15'), tile('15-24', 'g_15_24'), tile('24+', 'g_24')] },
    w_projekt: { key: 'proj', tiles: [tile('ja', 'p_ja', 'p_ja_d'), tile('nein', 'p_nein', 'p_nein_d')] },
    bootstyp: { key: 'boot', tiles: [tile('motor', 'b_motor'), tile('segel', 'b_segel'), tile('kat', 'b_kat')] },
    kiel: { key: 'kiel', img: true, tiles: [tile('kurz', 'k_kurz'), tile('lang', 'k_lang'), tile('gem', 'k_gem')] },
    h_kanal: { key: 'kanal', tiles: [tile('laden', 'c_laden'), tile('online', 'c_online'), tile('beides', 'c_beides')] },
    h_lager: { key: 'lager', tiles: [tile('lager', 'l_lager'), tile('auftrag', 'l_auftrag'), tile('beides', 'l_beides')] },
    h_appl: { key: 'appl', tiles: [tile('ja', 'a_ja'), tile('nein', 'a_nein'), tile('partner', 'a_partner')] },
    h_sortiment: { key: 'sort', tiles: [tile('ja', 's_ja'), tile('nein', 's_nein')] },
    h_umsatz: { key: 'umsatz', lead: 'h_umsatz_l', tiles: [tile('u25', 'u_25'), tile('25-100', 'u_25_100'), tile('100-250', 'u_100_250'), tile('250+', 'u_250'), tile('ka', 'u_ka')] }
  };
  var QUELLE = ['kunde', 'empfehlung', 'suche', 'social', 'messe', 'anderes'];
  function txt(id, label, o) { o = o || {}; return { id: id, kind: 'text', label: label, type: o.type || 'text', ac: o.ac || 'off', ph: o.ph || '', hint: o.hint || '', opt: !!o.opt, req: !o.opt, im: o.im || '', check: o.check || '' }; }
  function num(id, label, hint, max) { return { id: id, kind: 'num', label: label, hint: hint || '', req: true, max: max }; }
  function land() { return BYC[S.v.f_land] || BYC[defCountry]; }
  function addrRows(c) {
    var map = {
      a: function () { return txt('f_str', lab(c, 'la'), { ac: 'address-line1' }); },
      c: function () { return txt('f_ort', lab(c, 'lc'), { ac: 'address-level2' }); },
      z: function () {
        var l = c.c === 'IE' ? T.f_eircode : (LANG === 'de' && !c.lz ? T.f_plz : lab(c, 'lz'));
        return txt('f_plz', l, { ac: 'postal-code', ph: c.pe || '' });
      },
      p: function () {
        return { id: 'f_zone', kind: 'select', label: lab(c, 'lp'), ac: 'address-level1', req: true,
          options: [['', T.choose]].concat(c.z.map(function (z) { return [z[0], LANG === 'de' ? z[1] : (z[2] || z[1])]; })) };
      }
    };
    return c.r.split('|').map(function (row) { return row.split('').map(function (k) { return map[k](); }); });
  }
  function rowsFor(step) {
    var a = S.a;
    if (step === 'masse') return [[num('m_l', T.m_l, T.m_l_h, 120)], [num('m_b', T.m_b, a.boot === 'kat' ? T.m_b_kat : '', 40)], [num('m_t', T.m_t, '', 15)]];
    if (step === 'h_marken') {
      if (a.sort === 'nein') return [[txt('h_gebiet', T.f_gebiet_n, { ph: T.f_gebiet_ph })]];
      return [[txt('h_marken', T.f_marken, { ph: T.f_marken_ph })], [txt('h_gebiet', T.f_gebiet, { ph: T.f_gebiet_ph })]];
    }
    if (step === 'firma') {
      var c = land(), eu = EU.indexOf(c.c) > -1;
      var countryField = { id: 'f_land', kind: 'country', label: T.f_land, ac: 'country', req: true };
      var uid = txt('f_uid', (eu || c.c === 'CH') ? T.f_uid_eu : T.f_uid, { ph: UIDX[c.c] || '', opt: true });
      return [[txt('f_firma', T.f_firma, { ac: 'organization' })], [countryField], [uid]].concat(addrRows(c), [
        [txt('f_web', T.f_web, { ac: 'url', ph: 'www.', im: 'url', hint: T.f_web_h, check: 'web' })]]);
    }
    if (step === 'kontakt') {
      var cc = land();
      return [
        [txt('k_vn', T.k_vn, { ac: 'given-name' }), txt('k_nn', T.k_nn, { ac: 'family-name' })],
        [txt('k_mail', T.k_mail, { type: 'email', ac: 'email', check: 'mail' })],
        [txt('k_tel', T.k_tel, { type: 'tel', ac: 'tel', ph: cc && cc.ph ? '+' + cc.ph : '', check: 'tel' })],
        [{ id: 'k_quelle', kind: 'select', label: T.k_quelle, opt: true, req: false, ac: 'off',
          options: [['', T.choose]].concat(QUELLE.map(function (q) { return [q, T['q_' + q]]; })) }],
        [{ id: 'k_msg', kind: 'area', label: T.k_msg, ph: T.k_msg_ph, opt: true, req: false }],
        [{ id: 'k_ok', kind: 'check', req: true }]
      ];
    }
    return null;
  }
  function title(step) {
    if (step === 'h_marken' && S.a.sort === 'nein') return T.h_marken_n;
    return T[step] || '';
  }

  /* ---------- Darstellung ---------- */
  function fieldHtml(f) {
    var v = S.v[f.id] == null ? '' : S.v[f.id];
    var id = 'f2b-' + f.id, h = '';
    var label = f.label ? '<label class="f2b-lbl" for="' + id + '">' + esc(f.label) + (f.opt ? ' <span>' + esc(T.opt) + '</span>' : '') + '</label>' : '';
    if (f.kind === 'text') {
      h = label + '<input class="f2b-in" id="' + id + '" data-f="' + f.id + '" type="' + f.type + '" autocomplete="' + f.ac + '"' +
        (f.im ? ' inputmode="' + f.im + '"' : '') + (f.ph ? ' placeholder="' + esc(f.ph) + '"' : '') + (f.req ? ' aria-required="true"' : '') +
        ' value="' + esc(v) + '" maxlength="' + (f.id === 'f_web' ? 500 : (f.id === 'h_marken' || f.id === 'h_gebiet') ? 300 : 160) + '">';
    } else if (f.kind === 'num') {
      h = label + '<div class="f2b-num"><input class="f2b-in f2b-in--num" id="' + id + '" data-f="' + f.id + '" type="text" inputmode="decimal" autocomplete="off" aria-required="true" value="' + esc(v) + '" maxlength="8"><span class="f2b-unit" aria-hidden="true">' + esc(T.meter) + '</span></div>';
    } else if (f.kind === 'select') {
      h = label + '<select class="f2b-in f2b-sel" id="' + id + '" data-f="' + f.id + '" autocomplete="' + f.ac + '"' + (f.req ? ' aria-required="true"' : '') + '>' +
        f.options.map(function (o) { return '<option value="' + esc(o[0]) + '"' + (String(o[0]) === String(v) ? ' selected' : '') + '>' + esc(o[1]) + '</option>'; }).join('') + '</select>';
    } else if (f.kind === 'country') {
      var cur = land().c, opts = TOP.filter(function (c) { return BYC[c]; }).map(function (c) { return BYC[c]; });
      h = label + '<select class="f2b-in f2b-sel" id="' + id + '" data-f="f_land" data-country autocomplete="country" aria-required="true">' +
        opts.map(function (c) { return '<option value="' + c.c + '"' + (c.c === cur ? ' selected' : '') + '>' + esc(cName(c)) + '</option>'; }).join('') +
        '<option disabled>──────────</option>' +
        SORTED.filter(function (c) { return TOP.indexOf(c.c) < 0; }).map(function (c) { return '<option value="' + c.c + '"' + (c.c === cur ? ' selected' : '') + '>' + esc(cName(c)) + '</option>'; }).join('') +
        '</select>';
    } else if (f.kind === 'area') {
      h = label + '<textarea class="f2b-in f2b-ta" id="' + id + '" data-f="' + f.id + '" rows="3" maxlength="2000"' + (f.ph ? ' placeholder="' + esc(f.ph) + '"' : '') + '>' + esc(v) + '</textarea>';
    } else if (f.kind === 'check') {
      h = '<label class="f2b-check"><input type="checkbox" id="' + id + '" data-f="' + f.id + '"' + (v ? ' checked' : '') + ' aria-required="true"><span>' +
        T.k_ok.replace('{url}', esc(CFG.privacy || '/policies/privacy-policy')) + '</span></label>';
    }
    if (f.hint) h += '<p class="f2b-hint">' + esc(f.hint) + '</p>';
    h += '<p class="f2b-err" id="' + id + '-err" role="alert" hidden></p>';
    return '<div class="f2b-field f2b-field--' + f.kind + '">' + h + '</div>';
  }
  function progress(step) {
    if (step === 'done') return 100;
    var est = { seg: S.a.seg || 'werft', proj: S.a.proj || 'ja', boot: S.a.boot || 'segel', sort: S.a.sort || 'ja' };
    var p = path(est), i = p.indexOf(step);
    return Math.round(((i < 0 ? 0 : i) + 1) / (p.length + 1) * 100);
  }
  function prevOf(step) {
    if (step === 'segment' || step === 'done') return '';
    var p = path(S.a), i = p.indexOf(step);
    return i > 0 ? p[i - 1] : 'segment';
  }
  var sendErr = '';
  function render(focus) {
    var step = S.step, h = '', prev = prevOf(step);
    if (prev) h += '<button type="button" class="f2b-back" data-back>' + esc(T.back) + '</button>';
    else if (step !== 'done') h += '<p class="f2b-kicker">' + esc(T.kicker) + '</p>';
    h += '<div class="f2b-prog" aria-hidden="true"><div class="f2b-prog__fill" style="width:' + progress(step) + '%"></div></div>';
    h += '<h1 class="f2b-prompt" tabindex="-1">' + esc(step === 'done' ? T.done : title(step)) + '</h1>';
    if (step === 'done') {
      h += doneHtml();
    } else if (TILES[step]) {
      var d = TILES[step];
      if (d.lead) h += '<p class="f2b-lead">' + esc(T[d.lead]) + '</p>';
      if (step === 'segment' && CFG.customer && CFG.customer.b2b) {
        h += '<div class="f2b-box f2b-box--info"><p>' + esc(T.b2bIn) + ' <a href="' + esc(CFG.shop || CFG.root || '/') + '">' + esc(T.b2bShop) + '</a></p></div>';
      }
      h += '<div class="f2b-opts">' + d.tiles.map(function (t) {
        var sel = S.a[d.key] === t.id;
        if (d.img) {
          return '<button type="button" class="f2b-optimg' + (sel ? ' sel' : '') + '" data-pick="' + t.id + '" aria-pressed="' + sel + '"><img src="' + esc((CFG.keel || {})[t.id] || '') + '" alt="" width="62" height="62" loading="lazy"><span class="f2b-oi-t">' + esc(T[t.k]) + '</span></button>';
        }
        return '<button type="button" class="f2b-opt' + (sel ? ' sel' : '') + '" data-pick="' + t.id + '" aria-pressed="' + sel + '"><span class="f2b-opt-t">' + esc(T[t.k]) + '</span>' + (t.dk ? '<span class="f2b-opt-d">' + esc(T[t.dk]) + '</span>' : '') + '</button>';
      }).join('') + '</div>';
      if (step === 'segment') h += '<div class="f2b-login"><a href="' + esc(CFG.login || '/account/login') + '">' + esc(T.login) + '</a></div>';
    } else {
      var rows = rowsFor(step) || [];
      h += '<form class="f2b-form" novalidate data-step-form>';
      if (step === 'kontakt' && sendErr) h += '<div class="f2b-box f2b-box--warn" role="alert"><p>' + esc(sendErr) + '</p></div>';
      h += rows.map(function (r) { return '<div class="f2b-row">' + r.map(fieldHtml).join('') + '</div>'; }).join('');
      h += '<button type="submit" class="f2b-btn">' + esc(step === 'kontakt' ? T.send : T.next) + '</button></form>';
    }
    card.innerHTML = h;
    card.setAttribute('data-step', step);
    if (focus) {
      var hd = card.querySelector('.f2b-prompt');
      if (hd) { try { hd.focus({ preventScroll: true }); } catch (e) { hd.focus(); } }
      var sc = app.querySelector('.f2b-scroll'); if (sc) sc.scrollTop = 0;
      if (window.scrollY > 0) window.scrollTo(0, 0);
    }
    if (step === 'done') calPrep();
    if (step === 'kontakt') captchaPrime();
  }

  /* ---------- Pruefen ---------- */
  function parseNum(s) {
    var t = String(s || '').replace(/\s|m$/gi, '').replace(',', '.');
    if (!/^\d+(\.\d+)?$/.test(t)) return NaN;
    return parseFloat(t);
  }
  function fieldError(f) {
    var v = S.v[f.id];
    var s = typeof v === 'string' ? v.trim() : v;
    if (f.kind === 'check') return s ? '' : T.e_ok;
    if (!s) { if (!f.req) return ''; return (f.kind === 'select' || f.kind === 'country') ? T.e_pick : T.e_req; }
    if (f.kind === 'num') { var n = parseNum(s); return (n > 0 && n <= f.max) ? '' : T.e_num; }
    if (f.check === 'mail') return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(s) ? '' : T.e_mail;
    if (f.check === 'tel') return (s.replace(/\D/g, '').length >= 6) ? '' : T.e_tel;
    if (f.check === 'web') return /\S+\.\S{2,}/.test(s) ? '' : T.e_web;
    return '';
  }
  function showErr(f, msg) {
    var el = document.getElementById('f2b-' + f.id + '-err'), inp = document.getElementById('f2b-' + f.id);
    if (el) { el.textContent = msg || ''; el.hidden = !msg; }
    if (inp) { if (msg) { inp.setAttribute('aria-invalid', 'true'); inp.setAttribute('aria-describedby', 'f2b-' + f.id + '-err'); } else { inp.removeAttribute('aria-invalid'); } }
  }
  function validate(step) {
    var rows = rowsFor(step) || [], first = null;
    rows.forEach(function (r) { r.forEach(function (f) { var m = fieldError(f); showErr(f, m); if (m && !first) first = f; }); });
    if (first) { var el = document.getElementById('f2b-' + first.id); if (el) el.focus(); return false; }
    return true;
  }

  /* ---------- Navigation ---------- */
  var HI = 0, busy = false;
  function go(step, push) {
    S.step = step; save(); render(true); busy = false;
    if (push !== false) { HI++; try { history.pushState({ f2b: step, i: HI }, '', location.href); } catch (e) {} }
    else { try { history.replaceState({ f2b: step, i: HI }, '', location.href); } catch (e) {} }
  }
  function next() { go(flowNext(S.step, S.a)); }
  card.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pick]');
    if (b) {
      var d = TILES[S.step]; if (!d || busy) return;
      busy = true;
      S.a[d.key] = b.getAttribute('data-pick');
      Array.prototype.forEach.call(card.querySelectorAll('[data-pick]'), function (x) { x.classList.toggle('sel', x === b); x.setAttribute('aria-pressed', String(x === b)); });
      save();
      setTimeout(next, 160);
      return;
    }
    if (e.target.closest('[data-back]')) {
      var p = prevOf(S.step);
      if (p) { if (HI > 0 && history.state && history.state.f2b) { history.back(); } else { go(p, false); } }
      return;
    }
    var cl = e.target.closest('[data-cal]');
    if (cl && window.Calendly && Calendly.initPopupWidget) { e.preventDefault(); Calendly.initPopupWidget({ url: cl.getAttribute('href') }); }
  });
  card.addEventListener('input', function (e) {
    var f = e.target.getAttribute && e.target.getAttribute('data-f'); if (!f) return;
    S.v[f] = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    var err = document.getElementById('f2b-' + f + '-err'); if (err && !err.hidden) { err.hidden = true; e.target.removeAttribute('aria-invalid'); }
    save();
  });
  card.addEventListener('change', function (e) {
    var f = e.target.getAttribute && e.target.getAttribute('data-f'); if (!f) return;
    S.v[f] = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    if (e.target.hasAttribute('data-country')) {
      S.v.f_zone = ''; save(); render(false);
      var sel = document.getElementById('f2b-f_land'); if (sel) sel.focus();
      return;
    }
    var err = document.getElementById('f2b-' + f + '-err'); if (err && !err.hidden) { err.hidden = true; e.target.removeAttribute('aria-invalid'); }
    save();
  });
  card.addEventListener('submit', function (e) {
    if (!e.target.hasAttribute('data-step-form')) return;
    e.preventDefault();
    Array.prototype.forEach.call(e.target.querySelectorAll('[data-f]'), function (x) { S.v[x.getAttribute('data-f')] = x.type === 'checkbox' ? x.checked : x.value; });
    if (!validate(S.step)) return;
    if (S.step === 'kontakt') { submit(e.target.querySelector('.f2b-btn')); return; }
    next();
  });
  window.addEventListener('popstate', function (e) {
    var st = e.state && e.state.f2b;
    if (S.step === 'done') return;
    HI = e.state && typeof e.state.i === 'number' ? e.state.i : 0;
    busy = false;
    S.step = st && st !== 'done' ? st : 'segment';
    if (path(S.a).indexOf(S.step) < 0) S.step = 'segment';
    save(); render(true);
  });

  /* ---------- Versand ---------- */
  function deNum(s) { var n = parseNum(s); return isNaN(n) ? String(s || '') : String(n).replace('.', ','); }
  function enNum(s) { var n = parseNum(s); return isNaN(n) ? String(s || '') : String(n); }
  function tileLabel(step, id, tx) { var d = TILES[step]; if (!d) return id || ''; for (var i = 0; i < d.tiles.length; i++) if (d.tiles[i].id === id) return (tx || TD)[d.tiles[i].k]; return id || ''; }
  function v(k) { return String(S.v[k] == null ? '' : S.v[k]).trim(); }
  function answers(tx) {
    tx = tx || TD; var a = S.a, out = [], nf = tx === TD ? deNum : enNum;
    path(a).forEach(function (st) {
      if (st === 'w_groesse') out.push(['boat_sizes', tx === TD ? 'Bootsgrößen' : 'Boat sizes', tileLabel(st, a.groesse, tx)]);
      if (st === 'w_projekt') out.push(['project', tx === TD ? 'Konkretes Projekt' : 'Specific project', tileLabel(st, a.proj, tx)]);
      if (st === 'bootstyp') out.push(['boat_type', tx === TD ? 'Bootstyp' : 'Boat type', tileLabel(st, a.boot, tx)]);
      if (st === 'kiel') out.push(['keel', tx === TD ? 'Kiel' : 'Keel', tileLabel(st, a.kiel, tx)]);
      if (st === 'masse') {
        out.push(['lwl_m', tx === TD ? 'Länge Wasserlinie' : 'Waterline length', nf(v('m_l')) + ' m']);
        out.push(['beam_m', tx === TD ? 'Maximale Breite' : 'Maximum beam', nf(v('m_b')) + ' m']);
        out.push(['draft_m', tx === TD ? 'Tiefgang' : 'Draft', nf(v('m_t')) + ' m']);
      }
      if (st === 'h_kanal') out.push(['sales_channel', tx === TD ? 'Verkauf' : 'Sales channel', tileLabel(st, a.kanal, tx)]);
      if (st === 'h_lager') out.push(['stock', tx === TD ? 'Lager oder pro Auftrag' : 'Stock', tileLabel(st, a.lager, tx)]);
      if (st === 'h_appl') out.push(['application', tx === TD ? 'Applikation selbst' : 'Application', tileLabel(st, a.appl, tx)]);
      if (st === 'h_sortiment') out.push(['carries_antifouling', tx === TD ? 'Antifouling im Sortiment' : 'Stocks antifouling', tileLabel(st, a.sort, tx)]);
      if (st === 'h_umsatz') out.push(['antifouling_revenue', tx === TD ? 'Antifouling-Umsatz pro Jahr' : 'Antifouling revenue', tileLabel(st, a.umsatz, tx)]);
      if (st === 'h_marken') {
        if (a.sort !== 'nein') out.push(['brands', tx === TD ? 'Antifouling-Marken' : 'Brands', v('h_marken')]);
        out.push(['sales_area', tx === TD ? 'Verkaufsgebiet' : 'Sales area', v('h_gebiet')]);
      }
    });
    return out;
  }
  function zoneName(c, code) { if (!c || !c.z || !code) return ''; for (var i = 0; i < c.z.length; i++) if (c.z[i][0] === code) return c.z[i][1]; return code; }
  function addrLines(c) {
    var map = { a: v('f_str'), c: v('f_ort'), z: v('f_plz'), p: zoneName(c, v('f_zone')) };
    return c.r.split('|').map(function (row) { return row.split('').map(function (k) { return map[k]; }).filter(Boolean).join(' '); }).filter(Boolean).concat([cName(c, 'de')]);
  }
  function submit(btn) {
    var form = document.getElementById('f2b-send'), box = form && form.querySelector('[data-f2b-fields]');
    if (!form || !box) return;
    var c = land(), seg = S.a.seg === 'haendler' ? 'haendler' : 'werft';
    var inMarket = B2BC.length === 0 || B2BC.indexOf(c.c) > -1;
    var name = (v('k_vn') + ' ' + v('k_nn')).trim();
    var q = v('k_quelle'), quelle = q ? TD['q_' + q] : '';
    var F = [
      ['Anfrage', 'B2B-Anmeldung: ' + (seg === 'haendler' ? 'Händler' : 'Werft oder Servicebetrieb')],
      ['name', name], ['email', v('k_mail')], ['phone', v('k_tel')],
      ['Firma', v('f_firma')],
      [(EU.indexOf(c.c) > -1 || c.c === 'CH') ? 'UID' : 'Steuernummer', v('f_uid') || 'keine angegeben'],
      ['Adresse', addrLines(c).join('\n')],
      ['Land', cName(c, 'de') + ' (' + c.c + ')'],
      ['B2B-Markt', inMarket ? 'ja, ' + cName(c, 'de') + ' ist einem B2B-Markt zugeordnet. Nach dem Anlegen der Firma sieht der Kunde die B2B-Preise.'
        : 'NEIN, ' + cName(c, 'de') + ' ist in keinem B2B-Markt. Vor dem Anlegen der Firma das Land einem B2B-Markt zuordnen, sonst sieht der Kunde keine B2B-Preise.'],
      ['Steuer', esOutside() ? 'Kanaren, Ceuta oder Melilla: außerhalb des EU-Mehrwertsteuergebiets, Standort in Shopify steuerbefreit anlegen.'
        : (EU.indexOf(c.c) > -1 && c.c !== 'DE' ? (v('f_uid') ? 'UID angegeben: vor dem Eintragen in VIES prüfen, dann Reverse Charge.' : 'Keine UID: MwSt. des Lieferlands kommt dazu.') : (c.c === 'DE' ? 'Deutschland: 19 % MwSt.' : 'Export: ohne MwSt.'))],
      ['Website', v('f_web')]
    ];
    answers(TD).forEach(function (x) { F.push([x[1], x[2]]); });
    if (quelle) F.push(['Aufmerksam geworden durch', quelle]);
    F.push(['Sprache', LANG === 'de' ? 'Deutsch' : 'Englisch']);
    F.push(['Seite', location.pathname]);
    F.push(['body', v('k_msg') || '(keine Nachricht)']);
    box.innerHTML = '';
    F.forEach(function (p) {
      var el = document.createElement(p[1].indexOf('\n') > -1 || p[0] === 'body' ? 'textarea' : 'input');
      if (el.tagName === 'INPUT') el.type = 'hidden';
      el.name = 'contact[' + p[0] + ']'; el.value = p[1];
      box.appendChild(el);
    });
    var tel = seg === 'werft' && S.a.proj === 'ja';
    var ev = { segment: seg, segment_label: seg === 'haendler' ? 'Händler' : 'Werft oder Servicebetrieb', company: v('f_firma'),
      country: c.c, country_name: cName(c, 'de'), city: v('f_ort'), language: LANG, has_vat_id: !!v('f_uid'), b2b_market: inMarket,
      website: v('f_web'), source: quelle, message: v('k_msg') };
    answers(TD).forEach(function (x) { ev[x[0]] = x[2]; });
    var note = [];
    if (tel) {
      var nx = answers(T).filter(function (x) { return ['boat_type', 'keel', 'lwl_m', 'beam_m', 'draft_m'].indexOf(x[0]) > -1; }).map(function (x) { return x[0].slice(-2) === '_m' ? x[1] + ' ' + x[2] : x[2]; });
      note.push(T.cal_note_proj + ': ' + nx.join(', '));
    }
    note.push(T.cal_note_firma + ': ' + v('f_firma'));
    ssSet(SENT, { t: Date.now(), email: v('k_mail'), first: v('k_vn'), last: v('k_nn'), phone: v('k_tel'), ev: ev });
    ssSet(DONE, { t: Date.now(), seg: seg, tel: tel, name: name, email: v('k_mail'), note: note.join('. ') });
    if (btn) { btn.disabled = true; btn.textContent = T.sending; }
    sendErr = '';
    captchaReady(form, function (ok) {
      if (!ok) { sendFailed(); return; }
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
      setTimeout(function () { if (!leaving) sendFailed(); }, 90000);
    });
  }
  var leaving = false;
  window.addEventListener('pagehide', function () { leaving = true; });
  window.addEventListener('beforeunload', function () { leaving = true; });
  function sendForm() { return document.getElementById('f2b-send'); }
  function captchaOn() { return !!(window.Shopify && window.Shopify.captcha); }
  function captchaBound(form) { return form.hasAttribute('data-hcaptcha-bound') || form.hasAttribute('data-recaptcha-bound'); }
  function captchaPrime() {
    var form = sendForm();
    if (!form || !captchaOn() || captchaBound(form) || form.getAttribute('data-cptcha')) return;
    var ev;
    try { ev = new FocusEvent('focusin', { bubbles: true }); } catch (e) { ev = document.createEvent('Event'); ev.initEvent('focusin', true, false); }
    form.dispatchEvent(ev);
  }
  function captchaReady(form, cb) {
    if (!captchaOn() || captchaBound(form)) { cb(true); return; }
    captchaPrime();
    var t0 = Date.now();
    (function poll() {
      if (captchaBound(form)) { cb(true); return; }
      if (Date.now() - t0 > 20000) { cb(false); return; }
      setTimeout(poll, 150);
    })();
  }
  function sendFailed() {
    if (S.step !== 'kontakt') return;
    ssSet(SENT, null);
    sendErr = T.e_send.replace('{mail}', CFG.mail || '');
    render(false);
    var box = card.querySelector('.f2b-box--warn'); if (box && box.scrollIntoView) box.scrollIntoView({ block: 'center' });
  }

  /* ---------- Bestaetigung ---------- */
  function doneHtml() {
    var d = ssGet(DONE) || {}, h = '<div class="f2b-box f2b-box--good"><p><b>' + esc(T.done_b) + '</b>' + esc(T.done_t) + '</p></div>';
    if (d.seg === 'werft' && d.tel) {
      var base = ((CFG.cal || {})[LANG] || {}).tel;
      if (base) {
        var url = base + (base.indexOf('?') > -1 ? '&' : '?') + 'name=' + encodeURIComponent(d.name || '') + '&email=' + encodeURIComponent(d.email || '') + (d.note ? '&a1=' + encodeURIComponent(d.note) : '');
        h += '<p class="f2b-cal-lead">' + esc(T.cal_tel) + '</p>' +
          '<a class="f2b-btn f2b-btn--link" data-cal href="' + esc(url) + '" target="_blank" rel="noopener">' + esc(T.cal_tel_btn) + '</a>' +
          '<p class="f2b-cal-cap">' + esc(T.cal_tel_cap) + '</p>';
      }
    }
    return h;
  }
  function calPrep() {
    if (!card.querySelector('[data-cal]') || document.getElementById('f2b-cal-js')) return;
    var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = 'https://assets.calendly.com/assets/external/widget.css'; document.head.appendChild(l);
    var s = document.createElement('script'); s.id = 'f2b-cal-js'; s.async = true; s.src = 'https://assets.calendly.com/assets/external/widget.js'; document.head.appendChild(s);
  }
  function klaviyo(sent) {
    if (!sent || !sent.email) return;
    var k = window.klaviyo = window.klaviyo || [];
    if (!document.querySelector('script[src*="static.klaviyo.com/onsite/js"]')) {
      var s = document.createElement('script'); s.async = true;
      s.src = 'https://static.klaviyo.com/onsite/js/TWpCZk/klaviyo.js?company_id=TWpCZk';
      document.head.appendChild(s);
    }
    var ev = sent.ev || {};
    var p = { '$email': sent.email, '$first_name': sent.first || '', '$last_name': sent.last || '', '$organization': ev.company || '',
      '$country': ev.country_name || '', '$city': ev.city || '', 'b2b_segment': ev.segment_label || '', 'b2b_registered': new Date().toISOString().slice(0, 10), 'b2b_language': ev.language || '' };
    var ph = String(sent.phone || '').replace(/[\s\-\/().]/g, '');
    if (/^\+\d{7,15}$/.test(ph)) p['$phone_number'] = ph;
    k.push(['identify', p]);
    k.push(['track', 'B2B Registration Submitted', ev]);
  }

  /* ---------- Start ---------- */
  function init() {
    var sent = ssGet(SENT), fresh = sent && Date.now() - sent.t < 600000;
    var cust = CFG.customer;
    if (SRV.errors) {
      var st0 = ssGet(KEY);
      if (st0) { S.a = st0.a || {}; S.v = st0.v || {}; }
      S.step = 'kontakt';
      sendErr = T.e_send.replace('{mail}', CFG.mail || '') + (SRV.errors ? ' (' + SRV.errors + ')' : '');
      ssSet(SENT, null);
      render(false);
      return;
    }
    if (SRV.posted) {
      if (fresh) klaviyo(sent);
      ssSet(SENT, null);
      ssSet(KEY, null);
      S.step = 'done'; render(false);
      if (/[?&]contact_posted=/.test(location.search)) { try { history.replaceState(null, '', location.pathname + location.hash.replace('#contact_form', '')); } catch (e) {} }
      return;
    }
    var st = ssGet(KEY);
    if (st && Date.now() - st.t < TTL) {
      S.a = st.a || {}; S.v = st.v || {};
      S.step = st.step && st.step !== 'done' && path(S.a).indexOf(st.step) > -1 ? st.step : 'segment';
    }
    if (!S.v.f_land) S.v.f_land = defCountry;
    if (cust && !cust.b2b) {
      if (!S.v.k_mail && cust.email) S.v.k_mail = cust.email;
      if (!S.v.k_vn && cust.first) S.v.k_vn = cust.first;
      if (!S.v.k_nn && cust.last) S.v.k_nn = cust.last;
    }
    var hs = history.state;
    HI = hs && hs.f2b && typeof hs.i === 'number' ? hs.i : 0;
    try { history.replaceState({ f2b: S.step, i: HI }, '', location.href); } catch (e) {}
    render(false);
  }
  init();
})();
